import type { de } from "./de";

export const en: typeof de = {
  langSwitch: { de: "DE", en: "EN" },
  backToHome: "Back to Home",

  impressum: {
    title: "Legal Notice",
    subtitle: "Information pursuant to § 5 TMG",
    section1Title: "Information pursuant to § 5 TMG",
    name: "Sebastian Graebsch",
    address1: "c/o Online-Impressum.de #21775",
    address2: "Europaring 90",
    address3: "53757 Sankt Augustin",
    address4: "Germany",
    contactTitle: "Contact Information",
    emailLabel: "Email:",
    email: "contact@nexatice.dev",
    websiteLabel: "Website:",
    website: "https://nexatice.dev",
    verantwortlichTitle: "Responsible for Content",
    verantwortlichText: "Responsible for content pursuant to § 18 Abs. 2 MStV:",
    ustIdTitle: "VAT Identification Number",
    ustIdText: "As a small business within the meaning of § 19 UStG (German VAT Act), no VAT is charged and therefore no VAT identification number is available.",
    streitTitle: "Dispute Resolution",
    streitP1: "The European Commission provides a platform for online dispute resolution (ODR): ",
    streitLink: "https://ec.europa.eu/consumers/odr",
    streitP2: "We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.",
    haftContentTitle: "Liability for Content",
    haftContentP1: "As a service provider, we are responsible for our own content on these pages in accordance with general laws pursuant to § 7 Para. 1 TMG. However, pursuant to §§ 8 to 10 TMG, we are not obligated to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity.",
    haftContentP2: "Obligations to remove or block the use of information under general law remain unaffected. However, liability in this regard is only possible from the time of knowledge of a specific infringement. Upon becoming aware of corresponding infringements, we will remove this content immediately.",
    haftLinksTitle: "Liability for Links",
    haftLinksP1: "Our website contains links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for this third-party content. The respective provider or operator of the pages is always responsible for the content of the linked pages.",
    haftLinksP2: "The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking. However, permanent monitoring of the content of the linked pages is not reasonable without concrete evidence of a violation of the law. If we become aware of any legal violations, we will remove such links immediately.",
    urheberTitle: "Copyright",
    urheberP1: "The content and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution, or any form of commercialization of such material beyond the scope of the copyright law shall require the prior written consent of its respective author or creator.",
    urheberP2: "Downloads and copies of this site are only permitted for private, non-commercial use. Insofar as the content on this site was not created by the operator, the copyrights of third parties are respected. In particular, third-party content is marked as such. Should you nevertheless become aware of a copyright infringement, please inform us accordingly. If we become aware of any infringements, we will remove such content immediately.",
  },

  datenschutz: {
    title: "Privacy Policy",
    subtitle: "Information on the processing of your personal data",
    section1Title: "1. Controller",
    section1Text: "The controller responsible for data processing within the meaning of the General Data Protection Regulation (GDPR) is:",
    name: "Sebastian Graebsch",
    address1: "c/o Online-Impressum.de #21775",
    address2: "Europaring 90",
    address3: "53757 Sankt Augustin",
    address4: "Germany",
    contactEmail: "privacy@nexatice.dev",

    section2Title: "2. Overview of Processing Activities",
    section2Intro: "Below we inform you about the processing of your personal data. We process your data only on the basis of the legal provisions of the GDPR.",

    processing1Title: "a) Registration and Authentication",
    processing1Data: "Data processed: email address, password hash (bcrypt), session tokens (JWT), IP address (for rate-limiting security)",
    processing1Purpose: "Purpose: account management, authentication, security",
    processing1Basis: "Legal basis: Art. 6(1)(b) GDPR (contract performance)",
    processing1Retention: "Retention: duration of the account. Deleted accounts: 30 days. Sessions: automatic expiry after JWT expiration.",

    processing2Title: "b) License Management",
    processing2Data: "Data processed: license key, email address, device IDs (SHA-256 hashed), validation count, IP address",
    processing2Purpose: "Purpose: license activation, device management, license validation",
    processing2Basis: "Legal basis: Art. 6(1)(b) GDPR (contract performance)",
    processing2Retention: "Retention: duration of the license plus 10 years (commercial retention obligation under § 257 HGB).",

    processing3Title: "c) Payment Processing",
    processing3Data: "Data processed: Stripe customer ID, subscription ID, checkout session ID, billing email",
    processing3Purpose: "Purpose: Pro subscription billing, payment processing",
    processing3Basis: "Legal basis: Art. 6(1)(b) GDPR (contract performance)",
    processing3Retention: "Retention: duration of the subscription plus 10 years.",

    processing4Title: "d) Email Delivery",
    processing4Data: "Data processed: email address, email content type (welcome, password reset, support, etc.)",
    processing4Purpose: "Purpose: transactional emails (account, support, updates)",
    processing4Basis: "Legal basis: Art. 6(1)(b) GDPR (contract performance)",
    processing4Retention: "Retention: only during transmission. No storage by us after delivery.",

    processing5Title: "e) Support Requests",
    processing5Data: "Data processed: name, email address, message content, IP address",
    processing5Purpose: "Purpose: customer support",
    processing5Basis: "Legal basis: Art. 6(1)(b) GDPR (contract performance)",
    processing5Retention: "Retention: 12 months after the last interaction.",

    processing6Title: "f) Waitlist / Newsletter",
    processing6Data: "Data processed: email address, signup date",
    processing6Purpose: "Purpose: product updates, notifications",
    processing6Basis: "Legal basis: Art. 6(1)(a) GDPR (consent)",
    processing6Retention: "Retention: until unsubscription or withdrawal of consent.",

    processing7Title: "g) Rate Limiting and Security",
    processing7Data: "Data processed: IP address, requested path, request count, timestamp",
    processing7Purpose: "Purpose: security, abuse prevention",
    processing7Basis: "Legal basis: Art. 6(1)(f) GDPR (legitimate interest)",
    processing7Retention: "Retention: 24 hours (rate limit window) / 6 months (audit logs).",

    processing8Title: "h) Update Checks (Desktop Application)",
    processing8Data: "Data processed: application version, operating system type",
    processing8Purpose: "Purpose: software updates",
    processing8Basis: "Legal basis: Art. 6(1)(f) GDPR (legitimate interest)",
    processing8Retention: "Retention: not stored — ephemeral request without logging.",

    section3Title: "3. Recipients of Your Data",
    section3P1: "For the purposes listed above, we share your data with the following recipients:",
    recipient1: "Turso (libSQL) — database hosting for storing account data, licenses, and audit logs.",
    recipient2: "Vercel Inc. — server hosting for the website and API.",
    recipient3: "Stripe, Inc. — payment processing for the Pro subscription.",
    recipient4: "Resend, Inc. — email delivery for transactional emails.",

    section4Title: "4. Transfer to Third Countries",
    section4P1: "Stripe, Inc. and Resend, Inc. are based in the United States. Data transfer is carried out on the basis of Standard Contractual Clauses (SCCs) pursuant to Art. 46(2)(c) GDPR. Turso and Vercel operate servers within the EU/EEA.",

    section5Title: "5. Retention Period",
    section5P1: "The retention period depends on the deadlines specified above for each processing activity. After the retention period expires, data is routinely deleted unless statutory retention obligations require otherwise.",

    section6Title: "6. Your Rights",
    section6P1: "You have the following rights with respect to your personal data:",
    right1: "Right of access (Art. 15 GDPR)",
    right2: "Right to rectification (Art. 16 GDPR)",
    right3: "Right to erasure (Art. 17 GDPR)",
    right4: "Right to restriction of processing (Art. 18 GDPR)",
    right5: "Right to data portability (Art. 20 GDPR)",
    right6: "Right to object (Art. 21 GDPR)",
    right7: "Right to withdraw consent (Art. 7(3) GDPR)",
    section6P2: "To exercise your rights, please contact: privacy@nexatice.dev",

    section7Title: "7. Right to Complain",
    section7P1: "You have the right to lodge a complaint with a supervisory authority regarding the processing of your personal data (Art. 77 GDPR).",
    section7P2: "Competent supervisory authority:",
    authorityName: "Commissioner for Data Protection and Freedom of Information of North Rhine-Westphalia (LDI NRW)",
    authorityAddress: "Kavalleriestraße 2-4, 40210 Düsseldorf, Germany",
    authorityWebsite: "https://www.ldi.nrw.de",

    section8Title: "8. Cookies",
    section8P1: "Our website uses only technically necessary cookies required for the operation of the website. No consent is required pursuant to § 25 TTDSG. No tracking cookies or third-party cookies are used.",

    section9Title: "9. Data Security",
    section9P1: "We implement technical and organizational security measures to protect your data:",
    security1: "TLS encryption for all connections (HTTPS)",
    security2: "Password hashing with bcrypt (12 rounds)",
    security3: "SHA-256 hashing of device IDs",
    security4: "JWT session tokens with expiration",
    security5: "Rate limiting to prevent abuse",

    section10Title: "10. Changes to This Privacy Policy",
    section10P1: "We reserve the right to update this Privacy Policy to comply with current legal requirements or to reflect changes in our services. The current version is always available on this page.",

    section11Title: "11. Contact",
    section11P1: "For privacy-related questions, please contact:",
    contactEmail: "privacy@nexatice.dev",
  },

  agb: {
    title: "Terms of Service",
    subtitle: "Terms and conditions for the use of Nexatice",
    s1Title: "1. Scope",
    s1P1: "These Terms of Service apply to all uses of the software \"Nexatice\" (desktop application) and the associated backend services, provided by Sebastian Graebsch. Conflicting terms of the user are not accepted unless we expressly agree to them.",
    s2Title: "2. Subject of the Contract",
    s2P1: "Nexatice is a desktop application for database management. The free version (Free Tier) enables the management of database connections locally on the user's device. The Pro subscription extends the functionality with additional features.",
    s3Title: "3. Conclusion of Contract",
    s3P1: "By downloading and installing the software, the user accepts these Terms for the free version. For the Pro subscription, the contract is concluded through registration and completion of the subscription via the payment provider Stripe.",
    s4Title: "4. Free Tier",
    s4P1: "The free version of Nexatice is permanently available at no cost. The feature set may be expanded or modified at any time. There are no minimum terms or cancellation periods for the free version.",
    s5Title: "5. Pro Subscription",
    s5P1: "The Pro subscription is currently in development. The monthly price will be published on the website at launch and may change until then. The Pro subscription provides additional features that are marked as \"Pro\" features on the website.",
    s6Title: "6. License Scope",
    s6P1: "Each license entitles the use of Nexatice on up to 3 devices simultaneously that are owned or controlled by the user. Use for personal and commercial purposes is permitted.",
    s7Title: "7. Duration and Cancellation",
    s7P1: "The Pro subscription has a monthly term and automatically renews for an additional month unless cancelled before the end of the current period.",
    s7P2: "Cancellation is possible at any time without giving reasons and can be done via the user dashboard or by email to legal@nexatice.dev. Cancellation takes effect at the end of the current billing period.",
    s7P3: "After cancellation, access to the Pro subscription remains until the end of the paid period. Thereafter, an automatic switch to the free version occurs.",
    s8Title: "8. Prices and Payment",
    s8P1: "Prices for the Pro subscription are published on the website. Payment is processed via the payment provider Stripe. Billing occurs at the beginning of each billing period.",
    s8P2: "Price changes will be communicated to the user with reasonable advance notice. Price changes are deemed accepted if the user does not cancel before the start of the new billing period.",
    s9Title: "9. Right of Withdrawal",
    s9P1: "Consumers (§ 13 BGB) have a 14-day right of withdrawal for distance contracts pursuant to § 312g BGB.",
    s9P2: "The right of withdrawal expires for digital content pursuant to § 312g(2) No. 9 BGB if the consumer has expressly agreed that the provision of the digital content begins before the expiry of the withdrawal period and has confirmed their acknowledgement of this.",
    s9P3: "The corresponding consent statements will be requested and stored during the checkout process.",
    s10Title: "10. Warranty",
    s10P1: "The software is provided \"as is\". We do not warrant that the software will be uninterrupted, error-free, or secure. The user uses the software at their own risk.",
    s11Title: "11. Limitation of Liability",
    s11P1: "We shall not be liable for indirect, incidental, special, or consequential damages, including but not limited to data loss, database corruption, loss of profits, or business interruption.",
    s11P2: "Total liability is limited to the amount of fees paid in the last 12 months. The foregoing does not apply to damages arising from injury to life, body, or health or gross negligence.",
    s12Title: "12. Intellectual Property",
    s12P1: "All rights to the software, including the code, designs, and documentation, belong to us. The user may not modify, decompile, disassemble, or reverse-engineer the software.",
    s12P2: "The user may not rent, lease, sublicense, or resell the software.",
    s13Title: "13. Suspension and Termination by Us",
    s13P1: "We reserve the right to suspend or terminate a user's access if they violate these Terms, disregard legal provisions, or compromise the security of the service.",
    s14Title: "14. Final Provisions",
    s14P1: "The laws of the Federal Republic of Germany apply, excluding the UN Convention on Contracts for the International Sale of Goods.",
    s14P2: "The place of jurisdiction is, to the extent legally permitted, the seat of the provider.",
    s14P3: "Should individual provisions of these Terms be invalid or become invalid, the validity of the remaining provisions shall remain unaffected. In place of the invalid provision, a regulation shall apply that comes closest to the economic purpose of the invalid provision.",
    s15Title: "15. Contact",
    s15P1: "For questions about these Terms, please contact:",
    contactEmail: "legal@nexatice.dev",
  },
};
